import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "@/locales/en.json";
import es from "@/locales/es.json";
import { LANG_COOKIE_NAME, LANG_STORAGE_KEY } from "./i18n-constants";

export { LANG_COOKIE_NAME, LANG_STORAGE_KEY };

const resources = {
  en: { translation: en },
  "es-AR": { translation: es },
  es: { translation: es }, // fallback for legacy "es" cookie/localStorage
};

i18n.use(initReactI18next).init({
  resources,
  lng: "es-AR",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

/** Cookie / layout locale → i18n resource key (always one of these). */
export function normalizeLocale(lang: string | undefined): "en" | "es-AR" {
  return lang === "en" ? "en" : "es-AR";
}

/**
 * Keep the shared i18n singleton aligned with the user locale so SSR and the
 * client’s first paint match (avoids hydration mismatches on translated text).
 */
export async function syncI18nToCookieLocale(lang: string): Promise<void> {
  const target = normalizeLocale(lang);
  if (normalizeLocale(i18n.language) === target) return;
  await i18n.changeLanguage(target);
}

export default i18n;
